var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImage3222(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 168,
    height: 159,
    viewBox: "0 0 168 159",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M143.961 74.4187C143.961 77.5243 143.686 80.6238 143.142 83.6812C143.142 83.6812 141.844 108.427 93.0604 158.225C92.9264 158.356 92.7467 158.429 92.5595 158.429C92.3724 158.429 92.1927 158.356 92.0587 158.225C87.6994 153.976 56.0685 122.6 44.436 96.1337C44.3108 95.8603 44.1856 95.5754 44.0718 95.2906C43.423 93.7868 42.8539 92.2829 42.3531 90.8132C42.2506 90.517 42.1482 90.2208 42.0685 89.9245C41.4268 87.8659 40.9137 85.7694 40.532 83.647C40.532 83.647 40.532 83.5673 40.532 83.5331C40.0109 80.523 39.7481 77.4737 39.7466 74.4187C39.9489 60.7179 45.5283 47.6467 55.2794 38.0295C65.0305 28.4124 78.1702 23.0214 91.8596 23.0214C105.549 23.0214 118.689 28.4124 128.44 38.0295C138.191 47.6467 143.77 60.7179 143.973 74.4187H143.961Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M143.961 74.4187C143.961 77.5243 143.686 80.6238 143.142 83.6812C143.142 83.6812 141.844 108.427 93.0604 158.225C92.9264 158.356 92.7467 158.429 92.5595 158.429C92.3724 158.429 92.1927 158.356 92.0587 158.225C87.6994 153.976 56.0685 122.6 44.436 96.1337C44.3108 95.8603 44.1856 95.5754 44.0718 95.2906C43.423 93.7868 42.8539 92.2829 42.3531 90.8132C42.2506 90.517 42.1482 90.2208 42.0685 89.9245C41.4268 87.8659 40.9137 85.7694 40.532 83.647C40.532 83.647 40.532 83.5673 40.532 83.5331C40.0109 80.523 39.7481 77.4737 39.7466 74.4187C39.9489 60.7179 45.5283 47.6467 55.2794 38.0295C65.0305 28.4124 78.1702 23.0214 91.8596 23.0214C105.549 23.0214 118.689 28.4124 128.44 38.0295C138.191 47.6467 143.77 60.7179 143.973 74.4187H143.961Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M143.961 74.4187C143.961 77.5243 143.686 80.6238 143.142 83.6812C143.142 83.6812 141.844 108.427 93.0604 158.225C92.9264 158.356 92.7467 158.429 92.5595 158.429C92.3724 158.429 92.1927 158.356 92.0587 158.225C87.6994 153.976 56.0685 122.6 44.436 96.1337C44.3108 95.8603 44.1856 95.5754 44.0718 95.2906C43.423 93.7868 42.8539 92.2829 42.3531 90.8132C42.2506 90.517 42.1482 90.2208 42.0685 89.9245C41.4268 87.8659 40.9137 85.7694 40.532 83.647C40.532 83.647 40.532 83.5673 40.532 83.5331C40.0109 80.523 39.7481 77.4737 39.7466 74.4187C39.9489 60.7179 45.5283 47.6467 55.2794 38.0295C65.0305 28.4124 78.1702 23.0214 91.8596 23.0214C105.549 23.0214 118.689 28.4124 128.44 38.0295C138.191 47.6467 143.77 60.7179 143.973 74.4187H143.961Z",
    stroke: "#0A7F69",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M125.943 117.678L117.441 109.27C122.87 102.78 125.597 94.4484 125.057 86.0011C124.516 77.5538 120.749 69.6384 114.537 63.8953C108.324 58.1522 100.143 55.0217 91.6872 55.1524C83.2316 55.2831 75.1503 58.665 69.118 64.5973C63.0858 70.5297 59.565 78.5576 59.2851 87.0177C59.0053 95.4777 61.988 103.721 67.615 110.04C73.2421 116.359 81.0822 120.268 89.5107 120.958C97.9391 121.648 106.31 119.066 112.888 113.747L121.402 123.181L125.943 117.678Z",
    fill: "#DBFFF7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3643 90.8246C42.8651 92.2943 43.4342 93.7982 44.083 95.302C43.4345 93.8397 42.8609 92.3453 42.3643 90.8246Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0356 77.472L81.9966 11.6094",
    stroke: "#0A7F69",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0357 77.4721L19.7935 7.34851",
    stroke: "#0A7F69",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0357 77.472L14.7397 102.183",
    stroke: "#0A7F69",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8977 16.8388C25.5432 16.8388 29.3091 13.0693 29.3091 8.41939C29.3091 3.76949 25.5432 0 20.8977 0C16.2522 0 12.4863 3.76949 12.4863 8.41939C12.4863 13.0693 16.2522 16.8388 20.8977 16.8388Z",
    fill: "url(#paint0_linear_1284_73)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M112.66 101.91L122.608 112.927L127.115 107.413L117.167 97.5806L112.66 101.728",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M112.66 101.91L122.608 112.927L127.115 107.413L117.167 97.5806L112.66 101.728",
    stroke: "#0A7F69",
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M81.6781 15.5286C84.6263 15.5286 87.0163 13.1364 87.0163 10.1853C87.0163 7.23431 84.6263 4.84204 81.6781 4.84204C78.7298 4.84204 76.3398 7.23431 76.3398 10.1853C76.3398 13.1364 78.7298 15.5286 81.6781 15.5286Z",
    fill: "url(#paint1_linear_1284_73)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8091 8.41939C28.8091 12.7936 25.2666 16.3388 20.8977 16.3388C16.5288 16.3388 12.9863 12.7936 12.9863 8.41939C12.9863 4.04518 16.5288 0.5 20.8977 0.5C25.2666 0.5 28.8091 4.04518 28.8091 8.41939Z",
    stroke: "#0A7F69"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5163 10.1853C86.5163 12.8607 84.3497 15.0286 81.6781 15.0286C79.0064 15.0286 76.8398 12.8607 76.8398 10.1853C76.8398 7.51001 79.0064 5.34204 81.6781 5.34204C84.3497 5.34204 86.5163 7.51001 86.5163 10.1853Z",
    stroke: "#0A7F69"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7398 116.937C22.8804 116.937 29.4797 110.332 29.4797 102.183C29.4797 94.035 22.8804 87.4294 14.7398 87.4294C6.59925 87.4294 0 94.035 0 102.183C0 110.332 6.59925 116.937 14.7398 116.937Z",
    fill: "url(#paint2_linear_1284_73)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9797 102.183C28.9797 110.056 22.6038 116.437 14.7398 116.437C6.87584 116.437 0.5 110.056 0.5 102.183C0.5 94.3107 6.87584 87.9294 14.7398 87.9294C22.6038 87.9294 28.9797 94.3107 28.9797 102.183Z",
    stroke: "#0A7F69"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2764 110.899C111.494 110.899 126.262 96.1169 126.262 77.8822C126.262 59.6476 111.494 44.8655 93.2764 44.8655C75.0591 44.8655 60.291 59.6476 60.291 77.8822C60.291 96.1169 75.0591 110.899 93.2764 110.899Z",
    fill: "white",
    stroke: "#0A7F69",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M119.455 120.264L155.252 155.958C156.509 157.214 158.189 157.956 159.964 158.038C161.738 158.12 163.479 157.537 164.847 156.402C165.612 155.767 166.237 154.978 166.68 154.087C167.123 153.196 167.375 152.222 167.42 151.228C167.465 150.233 167.302 149.24 166.941 148.313C166.58 147.385 166.03 146.543 165.325 145.841L128.458 109.065L119.455 120.264Z",
    fill: "url(#paint3_linear_1284_73)",
    stroke: "#0A7F69",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2764 54.8115C93.2764 54.8115 115.528 56.6572 114.8 77.9164",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2764 54.8115C93.2764 54.8115 115.528 56.6572 114.8 77.9164",
    stroke: "#0A7F69",
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M119.455 114.567L155.252 150.262C156.509 151.518 158.189 152.259 159.964 152.341C161.738 152.424 163.479 151.84 164.847 150.706C165.612 150.07 166.237 149.282 166.68 148.391C167.123 147.499 167.375 146.525 167.42 145.531C167.465 144.537 167.302 143.544 166.941 142.616C166.58 141.689 166.03 140.847 165.325 140.145L128.458 103.368L119.455 114.567Z",
    fill: "white",
    stroke: "#0A7F69",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1284_73",
    x1: 12.1213,
    y1: 14.2797,
    x2: 28.278,
    y2: 22.3234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CDDB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#169C83"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1284_73",
    x1: 76.1082,
    y1: 13.9045,
    x2: 86.3619,
    y2: 19.0094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CDDB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#169C83"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1284_73",
    x1: 3.98374,
    y1: 105.954,
    x2: 31.5061,
    y2: 116.872,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CDDB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#169C83"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1284_73",
    x1: 125.938,
    y1: 139.815,
    x2: 170.963,
    y2: 157.324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CDDB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#169C83"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage3222);
export default __webpack_public_path__ + "static/media/image 32 (2) 2.188ddb938ffd77c6abd9ab88b79ae627.svg";
export { ForwardRef as ReactComponent };